import React from 'react';
import { GridItem } from '@fiverr-private/layout_components';
import { Image } from '@fiverr-private/media';
import type { Banner } from '@fiverr-private/store_builder_types';
import { theme } from '@fiverr-private/theme';
import { bannerItem } from './BannerCard.ve.css';

interface BannerCardProps {
    banner: Banner;
    isSelected: boolean;
    handleBannerClick: (bannerId: string) => void;
}

export const BannerCard = ({ banner, isSelected, handleBannerClick }: BannerCardProps) => (
    <GridItem
        className={bannerItem}
        height={{ default: 83, sm: 100 }}
        width={{ default: 150, sm: 176 }}
        borderRadius="sm"
        overflow="hidden"
        cursor="pointer"
        onClick={() => handleBannerClick(banner.id)}
        style={isSelected ? { boxShadow: `0 0 0 2px ${theme.colors.grey_1200}` } : undefined}
    >
        <Image
            objectFit="fill"
            height="100%"
            width="100%"
            src={banner.url}
            alt={`Banner ${banner.id}`}
            ratio="1.66/1"
        />
    </GridItem>
);
